import React, { Component } from "react";
import { Row, Col, Carousel, Button, Table } from "react-bootstrap";
import SignalDispatcher from "../utils/signalDispatcher";
import Cart from "../models/cart-model";
import TicketModel from "../models/ticket-model";
import signalDispatcherInstance from "../utils/signalDispatcher";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

interface CartTicketProps {
    tickets: Array<TicketModel>;
    hidden?: boolean;
}

interface CartTicketState {
    tickets: Array<TicketModel>;
    hidden?: boolean;
    translations: Record<string, any>;
}

class CartTicket extends Component<CartTicketProps, CartTicketState, TicketModel> {
    constructor(props: CartTicketProps) {
        super(props);
        this.state = {
            tickets: this.props.tickets,
            hidden: this.props.hidden ? this.props.hidden : false,
            translations: JSON.parse(localStorage.getItem('translations') || '[]')
        };
    }

    private navigatePage(url: string) {
        window.location.href = url;
    }

    private formatPrice(price: number) {
        return price !== null ? price.toLocaleString() : '';
    }

    private incrementTicket(ticket: TicketModel) {
        const updatedTickets = this.state.tickets.map(t =>
            t.id === ticket.id ? { ...t, quantity: t.quantity + 1 } : t
        );
        this.setState({ tickets: updatedTickets });
        let currentCount = 0;
        updatedTickets?.forEach(ticket => {
            currentCount += ticket.quantity;
        });
        signalDispatcherInstance.emit('refreshCartCount', currentCount);
        signalDispatcherInstance.emit('updateCartTicket', updatedTickets);
    }

    private decrementTicket(ticket: TicketModel) {
        const updatedTickets = this.state.tickets.map(t =>
            t.id === ticket.id && t.quantity > 1 ? { ...t, quantity: t.quantity - 1 } : t
        );
        this.setState({ tickets: updatedTickets });
        let currentCount = 0;
        updatedTickets?.forEach(ticket => {
            currentCount += ticket.quantity;
        });
        signalDispatcherInstance.emit('refreshCartCount', currentCount);
        signalDispatcherInstance.emit('updateCartTicket', updatedTickets);
    }

    private deleteTicket(ticket: TicketModel) {
        const updatedTickets = this.state.tickets.filter(t => t.id !== ticket.id);
        this.setState({ tickets: updatedTickets });
        let currentCount = 0;
        updatedTickets?.forEach(ticket => {
            currentCount += ticket.quantity;
        });
        signalDispatcherInstance.emit('refreshCartCount', currentCount);
        signalDispatcherInstance.emit('updateCartTicket', updatedTickets);
    }

    render() {
        return (
            <div className="oc-ticket-items">
                <Table responsive>
                    <thead>
                        <tr>
                            <th>{this.state.translations.filter((item: any) => item.setting_name === 'SERVICE_NAME')[0].setting_value_text}</th>
                            <th>{this.state.translations.filter((item: any) => item.setting_name === 'PRICE_PER_TICKET')[0].setting_value_text}</th>
                            <th>{this.state.translations.filter((item: any) => item.setting_name === 'PRICE_TOTAL')[0].setting_value_text}</th>
                            <th className="toRightPos">{this.state.translations.filter((item: any) => item.setting_name === 'AMOUNT')[0].setting_value_text}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.tickets.map((ticket, index) => (
                            <tr key={index}>
                                <td key={index+'_name'}>{ticket.name}</td>
                                <td key={index+'_price'}>{this.formatPrice(ticket.price)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                                <td key={index+'_gross'}>{this.formatPrice((ticket.price as number) * ticket.quantity)} HUF ({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</td>
                                <td key={index+'_qty'} className="oc-qty-col">
                                    <Button hidden={this.state.hidden} variant="light" disabled={ticket.quantity === 0 ? true : false} className="oc-btn oc-btn-qty" onClick={() => {this.decrementTicket(ticket)}}>-</Button>
                                    <input type="text" className="oc-input oc-input-count" value={ticket.quantity} readOnly />
                                    <Button hidden={this.state.hidden} variant="light" className="oc-btn oc-btn-qty" onClick={() => {this.incrementTicket(ticket)}}>+</Button>
                                </td>
                                <td key={index+'_delete'} className="toRightPos">
                                    <Button hidden={this.state.hidden} variant="light" className="oc-btn oc-btn-delete" onClick={() => {this.deleteTicket(ticket)}}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td><strong>{this.state.translations.filter((item: any) => item.setting_name === 'PRICE_TOTAL')[0].setting_value_text}:</strong></td>
                            <td colSpan={4} className="toRightPos">
                                <strong className="oc-total-price">
                                    {this.formatPrice(this.state.tickets.reduce((total, ticket) => total + ((ticket.price as number) * ticket.quantity), 0))} HUF <small>({this.state.translations.filter((item: any) => item.setting_name === 'VAT_INC')[0].setting_value_text})</small>
                                </strong>
                            </td>
                        </tr>
                    </tfoot>
                </Table>
            </div>
        );
    }
}

export default CartTicket;